import { iconsPath, imagePath } from './imagePath';

export const not_list = [
  {
    bg: '#EE2B2A',
    name: 'SpatialGrid',
    type: 'Platform Updates',
    time: 'Today',
    mess: 'SpatialGrid sent you a Platform Updates',
    title: '',
    desc: '',
    imp: true,
  },
  {
    bg: '#2A7FEE',
    name: 'Alexander Arnold',
    type: 'Sent a Comment',
    mess: 'Alexander Arnold left a comment saying:',
    time: 'Yesterday',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#2AEE7C',
    name: 'Virgil VD',
    type: 'Sent you an asset',
    mess: 'Virgil VD left a asset',
    time: '5th Jan 2025',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#2AEE7C',
    name: 'Virgil VD',
    type: 'Sent a Comment',
    mess: 'Virgil VD left a comment saying:',
    time: '4th Jan 2025',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#EE2B2A',
    name: 'Mohammed Salah',
    type: 'Sent you an asset',
    mess: 'Mohammed Salah left a asset',
    time: '3rd Jan 2025',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    title: '',
    imp: false,
  },
  {
    bg: '#2A7FEE',
    name: 'Alexander Arnold',
    type: 'Sent a Comment',
    mess: 'Alexander Arnold left a comment saying:',
    time: '2nd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#EE2B2A',
    name: 'Mohammed Salah',
    mess: 'Mohammed Salah left a asset',
    type: 'Sent you an asset',
    time: '3rd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#EE2B2A',
    name: 'Mohammed Salah',
    mess: 'Mohammed Salah left a asset',
    type: 'Sent you an asset',
    time: '3rd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#2A7FEE',
    name: 'Alexander Arnold',
    type: 'Sent a Comment',
    mess: 'Alexander Arnold left a comment saying:',
    time: '2nd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#EE2B2A',
    name: 'Mohammed Salah',
    mess: 'Mohammed Salah left a asset',
    type: 'Sent you an asset',
    time: '3rd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#EE2B2A',
    name: 'Mohammed Salah',
    type: 'Sent you an asset',
    mess: 'Mohammed Salah left a asset',
    time: '3rd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#2A7FEE',
    name: 'Alexander Arnold',
    type: 'Sent a Comment',
    mess: 'Alexander Arnold left a comment saying:',
    time: '2nd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#EE2B2A',
    name: 'Mohammed Salah',
    type: 'Sent you an asset',
    mess: 'Mohammed Salah left a asset',
    time: '3rd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
  {
    bg: '#EE2B2A',
    name: 'Mohammed Salah',
    type: 'Sent you an asset',
    mess: 'Mohammed Salah left a asset',
    time: '3rd Jan 2025',
    title: '',
    desc: "“ Useful plugin when you're putting templates together and alike. However only being able to replace text with english as opposed to generating x amount of tracking makes for a more complicated workflow in most cases. Oh also add the assets Virgil sent over yesterday, and connect the experiences. Add two hotspots on the field workings and filter components”",
    imp: false,
  },
];

export const TutorialsCategories = [
  {
    type: 'Basics',
    // type: "Basics",
    submenu: [
      {
        name: 'Getting Started',
        path: '/dashboard/tutorials',
        category: 'getting_started',
      },
    ],
  },
  {
    type: 'Use Cases',
    // type: "Use_Cases",
    submenu: [
      {
        name: 'Interactive 3D',
        category: 'interactive_3d',
        path: '/dashboard/tutorials',
      },
      {
        name: 'Surface Tracking',
        category: 'surface_tracking',
        path: '/dashboard/tutorials',
      },
      {
        name: 'Image Tracking',
        category: 'image_tracking',
        path: '/dashboard/tutorials',
      },
      {
        name: 'Location Tracking',
        category: 'location_tracking',
        path: '/dashboard/tutorials',
      },
      {
        name: 'Area Tracking',
        category: 'area_tracking',
        path: '/dashboard/tutorials',
      },
      {
        name: 'Virtual Spaces',
        category: 'virtual_spaces',
        path: '/dashboard/tutorials',
      },
      {
        name: 'VR Training',
        category: 'vr_training',
        path: '/dashboard/tutorials',
      },
    ],
  },

  // { name: "3D Assets", path: "/dashboard/library", category: "3D" },
  // { name: "Templates", path: "/dashboard/library", category: "templates" },
  // { name: "Scenes", path: "/dashboard/library", category: "scene" },
  // { name: "Images", path: "/dashboard/library", category: "image" },
  // { name: "Video", path: "/dashboard/library", category: "video" },
  // { name: "Audio", path: "/dashboard/library", category: "audio" },
  // { name: "Text", path: "/dashboard/library", category: "text" },
  // { name: "Vectors", path: "/dashboard/library", category: "vector" },
  // { name: "Sprites", path: "/dashboard/library", category: "sprite" },
];

export const LibraryCategories = [
  {
    name: '3D Assets',
    path: '/dashboard/library',
    category: '3D',
    icon: iconsPath.libraryIcons.libraryicon0,
    disabled: false,
  },
  {
    name: 'Templates',
    path: '/dashboard/library',
    category: 'templates',
    icon: iconsPath.libraryIcons.lbicon1,
    disabled: false,
  },
  {
    name: 'Scenes',
    path: '/dashboard/library',
    category: 'scene',
    icon: iconsPath.libraryIcons.lbicon2,
    disabled: false,
  },
  {
    name: 'Images',
    path: '/dashboard/library',
    category: 'image',
    icon: iconsPath.libraryIcons.lbicon3,
    disabled: false,
  },
  {
    name: 'Video',
    path: '/dashboard/library',
    category: 'video',
    icon: iconsPath.libraryIcons.lbicon4,
    disabled: false,
  },
  {
    name: 'Audio',
    path: '/dashboard/library',
    category: 'audio',
    icon: iconsPath.libraryIcons.lbicon5,
    disabled: false,
  },
  {
    name: 'Text',
    path: '/dashboard/library',
    category: 'text',
    icon: iconsPath.libraryIcons.lbicon6,
    disabled: false,
  },
  {
    name: 'Vectors',
    path: '/dashboard/library',
    category: 'vector',
    icon: iconsPath.libraryIcons.lbicon7,
    disabled: false,
  },
  {
    name: 'Sprites',
    path: '/dashboard/library',
    category: 'sprite',
    icon: iconsPath.libraryIcons.container,
    disabled: false,
  },
];


export const profileLinks = [
  { name: 'Account Details', link: '/profile' },
  { name: 'Settings', link: '/profile/setting' },
  { name: 'My Teams', link: '/profile/my-team' },
  { name: 'Invoices', link: '/profile/invoices' },
];

export const navLinks = [
  { name: 'Home', icon: imagePath?.group101Image, link: '/dashboard' },
  {
    name: 'My Projects',
    icon: imagePath?.group105Image,
    link: '/dashboard/myprojects',
  },
  {
    name: 'Library',
    icon: imagePath?.group41Image,
    link: '/dashboard/library',
    id: '3D',
    submenu: LibraryCategories,
  },
  { name: 'Teams', icon: imagePath?.group104Image, link: '/dashboard/teams' },
  {
    name: 'Tutorials',
    icon: imagePath?.group170Image,
    link: '/dashboard/tutorials',
    id: 'getting_started',
    submenu: TutorialsCategories,
  },
  {
    name: 'Analytics',
    icon: imagePath?.group103Image,
    link: '/dashboard/analytics',
  },
  {
    name: 'Notification',
    icon: imagePath?.group102Image,
    link: '/dashboard/notifications',
  },
  {
    name: 'Training',
    icon: imagePath?.group170Image,
    link: '/dashboard/training',
  },
];

export const AppTopectionData = [
  {
    title: '3D Asset',
    type: 'GLB, OBJ',
    icon: iconsPath?.vector8Image,
    accept: '.glb,.obj',
  },
  {
    title: 'Image',
    type: 'JPG, PNG',
    icon: iconsPath?.group74Image,
    accept: 'image/jpeg, image/png',
  },
  {
    title: 'Video',
    type: 'MP4',
    icon: iconsPath?.vector9Image,
    accept: 'video/mp4',
  },
  {
    title: 'Sound',
    type: 'MP3, WAV',
    icon: iconsPath?.group72Image,
    accept: 'audio/mpeg, audio/wav',
  },
  {
    title: 'Vector',
    type: 'SVG',
    icon: iconsPath?.group73Image,
    accept: 'image/svg+xml',
    badges: 'Coming Soon',
  },
  {
    title: 'Sprite',
    type: 'GIF',
    icon: iconsPath?.vector10Image,
    accept: 'image/gif',
    badges: 'Coming Soon',
  },
];

export const TextInitialData = {
  textType: '3D',
  content: 'Spatial Grid',
  fontSize: 80,
  color: '#ff6600',
  horizontal: 'center',
  vertical: 'center',
  extrusion: 0.001,
  bevelSize: 0.02,
  curveSegments: 12,
  metalness: 0.5,
  roughness: 0.5,
  fontFamily: 'Helvetiker', // Using local font
  fontWeight: 'regular',
};

export const HotSpotInitialData = {
  buttonShape: 'Circle',
  buttonText: '1',
  buttonColor: '#484848',
  buttonTextColor: '#000000',
  buttonOpacity: 0.5,
  autoFocus: false,
  functionType: 'Click',
  messageShape: 'Plane',
  messageText: 'Welcome to spatialgrid',
  messageTextColor: '#ffffff',
  messageBgColor: '#000000',
  messageOpacity: 0.5,
  messagePopupType: 'normal',
  focusDistance: 10,
};

// export const LightInitialData = {
//   id: '', // to be assigned dynamically
//   isLight: true,
//   intensity: 5,
//   hall: false,
//   light_type: 'Directional Light',
//   color: '#FFF4D6',
//   shadow: 'Soft Shadow',
//   name: 'Directional Light',
//   // New properties for all types
//   range: 15, // For spot, point, area
//   angle: Math.PI / 5, // For spot
//   width: 20, // For area
//   height: 20, // For area
// };

export const getLightInitialData = (lightType = 'Directional Light') => {
  const baseData = {
    id: '', // to be assigned dynamically
    isLight: true,
    hall: false,
    helperVisible: false,
    color: '#FFFFFF',
    shadow: 'Soft Shadow',
    // New properties for all types
    range: 15, // For spot, point, area
    angle: Math.PI / 8, // For spot
    width: 5, // For area
    height: 5, // For area
  };

  const lightTypeConfig = {
    'Spot Light': {
      intensity: 10,
      name: 'Spot Light',
      light_type: 'Spot Light',
    },
    'Directional Light': {
      intensity: 2,
      name: 'Directional Light',
      light_type: 'Directional Light',
    },
    'Point Light': {
      intensity: 10,
      name: 'Point Light',
      light_type: 'Point Light',
    },
    'Area Light': {
      intensity: 10,
      name: 'Area Light',
      light_type: 'Area Light',
    },
  };

  return {
    ...baseData,
    ...(lightTypeConfig[lightType] || lightTypeConfig['Directional Light']),
  };
};

export const LightInitialData = getLightInitialData('Directional Light');


export const windowTabs = [
  {
    label: 'Design',
    type: 'design',
    icon: iconsPath?.group131Image,
  },
  {
    label: 'Preview',
    type: 'preview',
    icon: iconsPath?.vector2Image,
  },
  {
    label: 'Code',
    type: 'code',
    icon: iconsPath?.group34Image,
  },
];

export const allComponentOptions = [
  'Events',
  'Audio',
  'Material',
  'Animation',
  'Light',
  'Video',
  'Physics',
  'Environment',
  'Particle',
  // 'HotSpot',
  // 'Camera',
];

export const options = [
  { value: 'ar', label: 'AR', icon: iconsPath?.arIcon },
  { value: 'vr', label: 'VR', icon: iconsPath?.vrIcon },
  { value: 'mr', label: 'MR', icon: iconsPath?.arDropDown },
  // { value: 'xr', label: 'XR', icon: iconsPath?.xrIcon },
];

export const getTransitionSteps = (type) => {
  // FROM AR TRANSITIONS
  if (type === 'ar-to-vr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from AR to VR.\nThis will change how user screen behaves.`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          {
            icon: iconsPath?.cameraTracking,
            text: 'tracking will be disabled',
          },
          { icon: iconsPath?.sceneAnchor, text: 'anchors will reset' },
          { icon: iconsPath?.vrHeadset, text: 'VR headset required' },
          { icon: iconsPath?.lightControl, text: 'Lighting will adapt' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'VR mode is heavier than AR and may take longer to load and use more memory.',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          {
            icon: iconsPath?.experiencDesktop,
            text: 'Desktop or high-end phone',
          },
          { icon: iconsPath?.experiencGpu, text: 'VR-ready GPU or headset' },
          { icon: iconsPath?.experiencRam, text: 'At least 4GB RAM' },
        ],
      },
    ];
  } else if (type === 'ar-to-mr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from AR to MR.\nThis will change how user screen behaves.`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          {
            icon: iconsPath?.cameraTracking,
            text: 'Depth & occlusion enabled',
          },
          { icon: iconsPath?.sceneAnchor, text: 'Surface detection' },
          { icon: iconsPath?.vrHeadset, text: 'Anchors/tracking stays on' },
          { icon: iconsPath?.lightControl, text: 'Enhanced scene' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'MR mode is slightly heavier than AR, but loads quickly on most devices',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrDesktop, text: 'Depth sensors preferred' },
          {
            icon: iconsPath?.mrMobile,
            text: ' Recent high-end phone or tablet',
          },
          { icon: iconsPath?.mrLight, text: ' Good ambient lighting' },
        ],
      },
    ];
  } else if (type === 'ar-to-xr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from AR to XR. Unlocks a richer environment with spatial depth and interaction.`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          { icon: iconsPath?.xrDepth, text: 'Depth & occlusion' },
          { icon: iconsPath?.xrSurface, text: ' Stable tracking' },
          { icon: iconsPath?.xrInteraction, text: ' Real-world interaction' },
          { icon: iconsPath?.xrTracking, text: ' Responsive surfaces' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description: 'XR is more immersive than AR and slightly heavier',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrMobile, text: ' High-end phone or desktop' },
          {
            icon: iconsPath?.experiencRam,
            text: '  4GB+ RAM and good lighting',
          },
          { icon: iconsPath?.xrDisplay, text: ' MR/XR-ready display' },
        ],
      },
    ];
  }

  // FROM VR TRANSITIONS
  else if (type === 'vr-to-ar') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You’re switching from VR to AR. Experience blends with the real world`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          {
            icon: iconsPath?.cameraTracking,
            text: 'Basic tracking via camera',
          },
          { icon: iconsPath?.vrArHeadset, text: 'No headset view' },
          { icon: iconsPath?.vrHeadset, text: 'Simpler visuals' },
          { icon: iconsPath?.vrArLoad, text: 'Faster load' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description: 'AR is lighter than VR and loads faster on most devices.',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrMobile, text: 'Any mid-range phone or tablet' },
          { icon: iconsPath?.vrArCamera, text: 'Basic camera access' },
          { icon: iconsPath?.experiencRam, text: '2GB+ RAM recommended' },
        ],
      },
    ];
  } else if (type === 'vr-to-mr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from VR to MR. This blends real-world views with digital layers for more interaction.`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          {
            icon: iconsPath?.cameraTracking,
            text: 'Mixed real + virtual view',
          },
          { icon: iconsPath?.sceneAnchor, text: 'Anchors active' },
          { icon: iconsPath?.vrHeadset, text: 'Surface tracking enabled' },
          { icon: iconsPath?.vrArLoad, text: 'Lower load' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description: 'MR is lighter than VR and works well on most devices',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrMobile, text: 'High-end phone or desktop' },
          { icon: iconsPath?.experiencRam, text: '4GB+ RAM' },
          { icon: iconsPath?.mrLight, text: 'Stable lighting environment' },
        ],
      },
    ];
  } else if (type === 'vr-to-xr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from VR to XR. This blends full immersion with real-world spatial awareness.`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          { icon: iconsPath?.cameraTracking, text: ' Partial real-world view' },
          { icon: iconsPath?.vrXrSensors, text: 'Camera & sensors' },
          { icon: iconsPath?.vrHeadset, text: 'Surface tracking ' },
          { icon: iconsPath?.vrArLoad, text: 'Light load shift' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'XR mode runs slightly lighter than VR and adapts quickly on capable devices.',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrMobile, text: 'High-end phone or desktop' },
          { icon: iconsPath?.experiencRam, text: '4GB+ RAM' },
          { icon: iconsPath?.vrArCamera, text: 'Basic camera access' },
        ],
      },
    ];
  }

  // FROM MR TRANSITIONS
  else if (type === 'mr-to-ar') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You’re switching from MR to AR. You’ll see only digital content, without real-world blending.`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          {
            icon: iconsPath?.cameraTracking,
            text: ' No real-world visibility',
          },
          { icon: iconsPath?.vrXrSensors, text: 'Reduced sensor use' },
          { icon: iconsPath?.vrHeadset, text: 'Basic surface tracking' },
          { icon: iconsPath?.vrArLoad, text: 'Light load shift' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description: 'AR is lighter than MR and runs smoothly on most devices',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrMobile, text: 'Mobile or tablet device' },
          { icon: iconsPath?.experiencRam, text: 'At least 2GB RAM' },
          {
            icon: iconsPath?.mrArLatestBrowser,
            text: 'Latest browser or app version',
          },
        ],
      },
    ];
  } else if (type === 'mr-to-vr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from MR to VR. This will shift to a fully immersive environment`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          {
            icon: iconsPath?.mrVrPhysicalTrack,
            text: ' Physical movement track',
          },
          { icon: iconsPath?.vrXrSensors, text: 'Higher scene realism' },
          { icon: iconsPath?.mrVrController, text: ' Input via controllers ' },
          { icon: iconsPath?.cameraTracking, text: ' Full digital view' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'VR is more resource-intensive and may take longer to load, depending on your device.',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrMobile, text: 'Mobile or tablet device' },
          { icon: iconsPath?.mrVrHeadset, text: ' VR headset or VR-ready GPU' },
          { icon: iconsPath?.mrVrWebXr, text: ' WebXR-compatible browser' },
        ],
      },
    ];
  } else if (type === 'mr-to-xr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from MR to XR. This enables advanced layering of digital content`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          { icon: iconsPath?.mrXrLayring, text: 'Deeper scene layering' },
          { icon: iconsPath?.mrXrSpace, text: 'Smarter space use' },
          { icon: iconsPath?.mrVrController, text: 'More tracking options' },
          { icon: iconsPath?.vrArLoad, text: 'Slightly higher load' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'XR is slightly heavier than MR but still optimized for most modern devices.',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrMobile, text: 'High-end phone or desktop' },
          { icon: iconsPath?.experiencRam, text: 'Minimum 4GB RAM' },
          { icon: iconsPath?.mrVrHeadset, text: 'Stable environment lighting' },
        ],
      },
    ];
  }

  // FROM XR TRANSITIONS
  else if (type === 'xr-to-ar') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from XR to AR. This returns you to a simpler, camera-based view`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          { icon: iconsPath?.mrXrLayring, text: 'Basic 3D layering' },
          { icon: iconsPath?.vrXrSensors, text: 'Lower sensor usage' },
          { icon: iconsPath?.vrHeadset, text: 'Limited surface tracking' },
          { icon: iconsPath?.vrArLoad, text: 'Light system load' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'AR mode is lightweight and performs well on almost all devices.',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          {
            icon: iconsPath?.mrMobile,
            text: 'Any modern smartphone or tablet',
          },
          { icon: iconsPath?.mrDesktop, text: 'Basic motion sensors' },
          { icon: iconsPath?.vrArCamera, text: 'Camera access' },
        ],
      },
    ];
  } else if (type === 'xr-to-vr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from XR to VR. This will shift to a fully virtual environment`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          { icon: iconsPath?.xrVrView, text: 'Real-world view off' },
          { icon: iconsPath?.xrVrVisuals, text: 'Richer virtual visuals' },
          { icon: iconsPath?.xrVrTracking, text: 'Headset-based tracking' },
          { icon: iconsPath?.vrArLoad, text: 'Slight load increase' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'VR mode is heavier than XR and may require more device power',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.mrVrHeadset, text: 'VR-ready headset or device' },
          { icon: iconsPath?.experiencRam, text: 'At least 4GB RAM' },
          { icon: iconsPath?.xrVrGpu, text: 'Powerful GPU' },
        ],
      },
    ];
  } else if (type === 'xr-to-mr') {
    return [
      {
        title: 'Switch Experience Mode',
        description: `You're switching from XR to MR. This brings a more real-world blend with simpler spatial layers`,
        icon: iconsPath?.experienceSwitch,
      },
      {
        title: 'What Will Change',
        description: [
          { icon: iconsPath?.xrVrView, text: 'Reduced visual layering' },
          { icon: iconsPath?.vrXrSensors, text: ' Camera & sensor ' },
          { icon: iconsPath?.vrHeadset, text: 'Real-environment blending' },
          { icon: iconsPath?.vrArLoad, text: 'Light System load' },
        ],
        icon: iconsPath?.experienceChange,
      },
      {
        title: 'Experience Load Notice',
        description:
          'MR mode is lighter than XR and loads quickly on most modern devices.',
        icon: iconsPath?.experienceLoad,
        recommendations: [
          { icon: iconsPath?.vrArCamera, text: 'Camera access required' },
          { icon: iconsPath?.experiencRam, text: 'At least 4GB RAM' },
          { icon: iconsPath?.xrVrGpu, text: 'Moderate CPU/GPU capability' },
        ],
      },
    ];
  }

  return [];
};

export const trackingOptions = [
  {
    value: 'surface',
    label: 'Surface',
    description: 'Detect and anchor content to flat surfaces',
  },
  {
    value: 'world',
    label: 'World',
    description: 'Track objects and surfaces in the environment',
  },
  {
    value: 'location',
    label: 'Location',
    description: 'Trigger experiences based on GPS or coordinates',
  },
  {
    value: 'body',
    label: 'Body',
    description: 'Track human body movements and gestures',
  },
  // {
  //   value: 'face',
  //   label: 'Face',
  //   description: 'Track facial features and expressions',
  // },
  // {
  //   value: 'area',
  //   label: 'Area',
  //   description: 'Recognize and map predefined physical spaces',
  // },
];

export const assetIcons = {
  image: iconsPath.group74Image,
  video: iconsPath.vector9Image,
  audio: iconsPath.group72Image,
  mesh: iconsPath.vector8Image,
  text: iconsPath.text,
  hotspot: iconsPath.group40Image || iconsPath.vector8Image,
  terrain: iconsPath.Element1Image,
  water: iconsPath.Element2Image,
  clouds: iconsPath.Element3Image,
  stars: iconsPath.Layer11Image,
  rain: iconsPath.Element4Image,
  snow: iconsPath.Element5Image,
  fire: iconsPath.Element6Image,
  foliage: iconsPath.Element7Image,
  particle: iconsPath.Element1Image,
  hotspot: iconsPath.group40Image || iconsPath.vector8Image,
  default: iconsPath.group26Image, // generic fallback
};

export const shapesIcon = {
  plane: iconsPath?.Layer1Image,
  cube: iconsPath?.Layer12Image,
  sphere: iconsPath?.Layer2Image,
  cylinder: iconsPath?.Layer3Image,
  cone: iconsPath?.Layer4Image,
  pyramid: iconsPath?.Layer13Image,
  capsule: iconsPath?.Layer5Image,
  torus: iconsPath?.Layer6Image,
  rectangle: iconsPath?.Layer7Image,
  ellipse: iconsPath.Layer8Image,
  triangle: iconsPath?.Layer9Image,
  pentagon: iconsPath?.Layer10Image,
  star: iconsPath?.Layer11Image,
};
